<script lang="ts" setup>
import { CARREFOUR_REFERENTIAL_INTERVAL_KEY } from '#components/dynamicForm/fields/PeriodField/constants/periodField.constant';
import SpinnerLoader from '#components/elements/spinner/SpinnerLoader.vue';
import { useLanguage } from '#composables/useLanguage';
import { useFormFieldsStore } from '#stores/formFields.store';
import { DEFAULT_CARREFOUR_REFERENTIAL_INTERVAL } from '@carrefour-gcs/shared';
import { computed, inject, ref } from 'vue';
import DynamicForm from './DynamicForm.vue';
import type { FilterFormPropsType } from './types/filterFormProps.type';

const { fields: fieldDefinitions, groupName, isActive = true } = defineProps<FilterFormPropsType>();

const emit = defineEmits<{
  cancel: [];
  submitted: [];
}>();

const { t } = useLanguage();
const formStore = useFormFieldsStore();

const fields = computed(() => fieldDefinitions);

const referentialIntervalKey = inject(CARREFOUR_REFERENTIAL_INTERVAL_KEY, ref(DEFAULT_CARREFOUR_REFERENTIAL_INTERVAL));

const onSubmit = (data: Record<string, unknown>) => {
  formStore.setLastSubmitted({
    groupName,
    data,
    referentialIntervalKey: referentialIntervalKey.value
  });
  emit('submitted');
};

const onCancel = () => {
  emit('cancel');
};
</script>

<template>
  <div v-if="formStore.loading" class="text-center py-4 flex align-middle justify-center">
    <span>{{ t('filters.form.status.loading') }}</span>
    <SpinnerLoader size="small" />
  </div>

  <div v-else-if="formStore.error" class="text-center py-4 text-red-600">
    {{ t('filters.form.status.error') }} {{ formStore.error }}
  </div>

  <DynamicForm v-else :fields="fields" :is-active="isActive" @submit="onSubmit" @cancel="onCancel" />
</template>
